<ui-section [title]="labels.widgetTitle | translate" [subtitle]="labels.widgetSubtitle | translate">
    <ui-section-content>
        <developer-helper [datasourceCode]="OldDataSourceCode.BUILDING_INDICATOR" />

        @let ranges = ranges$ | async;
        @let value = value$ | async;

        @if (!isLoading && !hasError && !hasNoData) {
            <scale [ranges]="ranges" [value]="value" [labels]="labels" />
        } @else {
            <loading-and-error [isLoading]="isLoading" [hasError]="hasError" [hasNoData]="hasNoData" />
        }
    </ui-section-content>
</ui-section>
